export const AuthorityUserMenu = (notificationCount) => [
  {
    title: "Dashboard",
    url: "/authority/dashboard",
    icon: "pi pi-th-large"
  },
  {
    title: (
      <>
        Notifications
        {notificationCount != 0 && <span className="notification-count">{notificationCount}</span>}
      </>
    ),
    url: "/notification",
    icon: "pi pi-bell"
  },
  {
    title: "Cases List",
    url: "/authority/case/list",
    icon: "pi pi-home"
  }
];
